/**
 * `rosterCity` translations: days a person must be in the city, drawn on the roster Schedule.
 */
export const rosterCity = {
  mn: {
    rosterCity: {
      label: 'Хотод байх өдөр',
      chip: 'Хотод',
      warn_one: 'Хотод байх {{count}} өдөрт ажил төлөвлөлөө.',
      warn_other: 'Хотод байх {{count}} өдөрт ажил төлөвлөлөө.',
      warnDay: '{{name}} {{day}}-нд хотод байх ёстой.',
      warnDayReason: '{{name}} {{day}}-нд хотод байх ёстой: {{reason}}.',
      warnMore_one: 'Бас {{count}} өдөр.',
      warnMore_other: 'Бас {{count}} өдөр.',
      loading: 'Хотод байх өдрүүд ачаалж байна',
      failed: 'Хотод байх өдрүүдийг ачаалж чадсангүй тул анхааруулга харуулах боломжгүй; хуудсаа дахин ачаална уу',
      manage: 'Хот',
      title: 'Хотод байх өдрүүд',
      help: 'Эдгээр өдөр тухайн хүнд ажил төлөвлөж болно, гэхдээ хадгалахаас өмнө анхааруулга гарна.',
      person: 'Ажилтан',
      from: 'Эхлэх',
      to: 'Дуусах',
      reason: 'Шалтгаан',
      add: 'Нэмэх',
      save: 'Хадгалах',
      edit: 'Засах',
      remove: 'Устгах',
      cancel: 'Болих',
      none: 'Энэ хугацаанд хотод байх өдөр алга.',
      saved: 'Хадгаллаа',
      removed: 'Устгалаа',
      failed_save: 'Хадгалж чадсангүй',
      needPerson: 'Ажилтан сонгох',
      needStart: 'Эхлэх огноог оруулна уу',
      needEnd: 'Дуусах огноог оруулна уу',
      endBeforeStart: 'Дуусах огноо эхлэхээс өмнө байж болохгүй',
      confirmRemove: '{{name}}-ийн хотод байх өдрийг ({{range}}) устгах уу?',
      failed_remove: 'Устгаж чадсангүй',
      batchHelp: 'Сонгосон өдрүүдийг хүн бүрээр нэг хугацаа болгон тэмдэглэнэ. Шалтгаанаа оруулна уу.',
      savedMany: '{{count}} тэмдэглэгээ хадгаллаа',
      failedSome: '{{count}}-аас {{failed}} нь хадгалагдсангүй',
      needReason: 'Шалтгаанаа оруулна уу',
      buttonTip: 'Сонгосон нүдийг хотод байх өдөр болгох, эсвэл жагсаалтыг нээх',
    },
  },
  en: {
    rosterCity: {
      label: 'In the city',
      chip: 'City',
      warn_one: 'Work is planned on {{count}} city day.',
      warn_other: 'Work is planned on {{count}} city days.',
      warnDay: '{{name}} is marked to be in the city on {{day}}.',
      warnDayReason: '{{name}} is marked to be in the city on {{day}}: {{reason}}.',
      warnMore_one: 'And {{count}} more.',
      warnMore_other: 'And {{count}} more.',
      loading: 'City days are still loading',
      failed: 'City days could not be loaded, so their warning cannot be shown; reload the page',
      manage: 'City',
      title: 'City days',
      help: 'Work can still be planned for the person on these days; planning it shows a warning first.',
      person: 'Person',
      from: 'From',
      to: 'To',
      reason: 'Reason',
      add: 'Add',
      save: 'Save',
      edit: 'Edit',
      remove: 'Remove',
      cancel: 'Cancel',
      none: 'No city days in this period.',
      saved: 'Saved',
      removed: 'Removed',
      failed_save: 'Could not save',
      needPerson: 'Choose a person',
      needStart: 'Enter a start date',
      needEnd: 'Enter an end date',
      endBeforeStart: 'The end date is before the start date',
      confirmRemove: 'Remove the city days of {{name}}, {{range}}?',
      failed_remove: 'Could not remove',
      batchHelp: 'Each run of selected days becomes one range per person. Enter the reason.',
      savedMany: '{{count}} marks saved',
      failedSome: '{{failed}} of {{count}} marks were not saved',
      needReason: 'Enter a reason',
      buttonTip: 'Mark the selected cells as city days, or open the list',
    },
  },
  ru: {
    rosterCity: {
      label: 'В городе',
      chip: 'Город',
      warn_one: 'Работа запланирована на {{count}} день в городе.',
      warn_few: 'Работа запланирована на {{count}} дня в городе.',
      warn_many: 'Работа запланирована на {{count}} дней в городе.',
      warn_other: 'Работа запланирована на {{count}} дня в городе.',
      warnDay: '{{name}}: день в городе {{day}}.',
      warnDayReason: '{{name}}: день в городе {{day}} — {{reason}}.',
      warnMore_one: 'И ещё {{count}}.',
      warnMore_few: 'И ещё {{count}}.',
      warnMore_many: 'И ещё {{count}}.',
      warnMore_other: 'И ещё {{count}}.',
      loading: 'Дни в городе ещё загружаются',
      failed: 'Не удалось загрузить дни в городе, поэтому предупреждение о них нельзя показать; перезагрузите страницу',
      manage: 'Город',
      title: 'Дни в городе',
      help: 'В эти дни человеку можно запланировать работу, но сначала появится предупреждение.',
      person: 'Сотрудник',
      from: 'С',
      to: 'По',
      reason: 'Причина',
      add: 'Добавить',
      save: 'Сохранить',
      edit: 'Изменить',
      remove: 'Удалить',
      cancel: 'Отмена',
      none: 'В этом периоде дней в городе нет.',
      saved: 'Сохранено',
      removed: 'Удалено',
      failed_save: 'Не удалось сохранить',
      needPerson: 'Выберите сотрудника',
      needStart: 'Укажите дату начала',
      needEnd: 'Укажите дату окончания',
      endBeforeStart: 'Дата окончания раньше даты начала',
      confirmRemove: 'Удалить дни в городе: {{name}}, {{range}}?',
      failed_remove: 'Не удалось удалить',
      batchHelp: 'Выбранные дни отмечаются одним периодом на человека. Укажите причину.',
      savedMany: 'Сохранено отметок: {{count}}',
      failedSome: 'Не сохранено {{failed}} из {{count}}',
      needReason: 'Укажите причину',
      buttonTip: 'Отметить выбранные ячейки как дни в городе или открыть список',
    },
  },
}
